/**
 * Financial Health Survey Models
 */

// Model for individual answer
export function FinHealthAnswerModel(dict) {
    this.category = dict.Category || '';
    this.questionNumber = dict.QuestionNumber || 0;
    this.question = dict.Question || '';
    this.answer = dict.Answer || '';
    this.score = dict.Score || 0;
}

// Model for category score
export function FinHealthCategoryScoreModel(dict) {
    this.questionScores = dict.QuestionScores || [];
    this.categoryAverage = dict.CategoryAverage || 0;
}

// Model for survey answer response
export function FinHealthSurveyResultModel(dict) {
    this.userId = dict.UserId || '';
    
    // Individual question data
    this.spendQ1Question = dict.Spend_Q1_Question || '';
    this.spendQ1Answer = dict.Spend_Q1_Answer || '';
    this.spendQ1Score = dict.Spend_Q1_Score || 0;
    this.spendQ2Question = dict.Spend_Q2_Question || '';
    this.spendQ2Answer = dict.Spend_Q2_Answer || '';
    this.spendQ2Score = dict.Spend_Q2_Score || 0;
    
    this.saveQ1Question = dict.Save_Q1_Question || '';
    this.saveQ1Answer = dict.Save_Q1_Answer || '';
    this.saveQ1Score = dict.Save_Q1_Score || 0;
    this.saveQ2Question = dict.Save_Q2_Question || '';
    this.saveQ2Answer = dict.Save_Q2_Answer || '';
    this.saveQ2Score = dict.Save_Q2_Score || 0;
    
    this.borrowQ1Question = dict.Borrow_Q1_Question || '';
    this.borrowQ1Answer = dict.Borrow_Q1_Answer || '';
    this.borrowQ1Score = dict.Borrow_Q1_Score || 0;
    
    this.planQ1Question = dict.Plan_Q1_Question || '';
    this.planQ1Answer = dict.Plan_Q1_Answer || '';
    this.planQ1Score = dict.Plan_Q1_Score || 0;
    this.planQ2Question = dict.Plan_Q2_Question || '';
    this.planQ2Answer = dict.Plan_Q2_Answer || '';
    this.planQ2Score = dict.Plan_Q2_Score || 0;
    
    // Category scores
    this.spendCategoryScore = dict.SpendCategoryScore || 0;
    this.saveCategoryScore = dict.SaveCategoryScore || 0;
    this.borrowCategoryScore = dict.BorrowCategoryScore || 0;
    this.planCategoryScore = dict.PlanCategoryScore || 0;
    
    // Total score and level
    this.totalScore = dict.TotalScore || 0;
    this.wellnessLevel = dict.WellnessLevel || '';
    
    // Time tracking
    this.timeSpentSeconds = dict.TimeSpentSeconds || 0;
    this.submittedAt = dict.SubmittedAt || 0;
    
    // Answers array
    this.answers = [];
    if (dict.Answers && dict.Answers instanceof Array) {
        for (var i = 0; i < dict.Answers.length; i++) {
            this.answers.push(new FinHealthAnswerModel(dict.Answers[i]));
        }
    }
    
    // Category score details
    if (dict.SpendScore) {
        this.spendScore = new FinHealthCategoryScoreModel(dict.SpendScore);
    }
    if (dict.SaveScore) {
        this.saveScore = new FinHealthCategoryScoreModel(dict.SaveScore);
    }
    if (dict.BorrowScore) {
        this.borrowScore = new FinHealthCategoryScoreModel(dict.BorrowScore);
    }
    if (dict.PlanScore) {
        this.planScore = new FinHealthCategoryScoreModel(dict.PlanScore);
    }
}

// Model for submit survey request
export function FinHealthSubmitRequestModel() {
    this.answers = [];
    this.timeSpentSeconds = 0;
}

// Model for submit answer item
export function FinHealthSubmitAnswerModel(category, questionNumber, answer) {
    this.category = category;
    this.questionNumber = questionNumber;
    this.answer = answer;
}

// Model for submit survey response
export function FinHealthSubmitResponseModel(dict) {
    this.userId = dict.UserId || '';
    this.spendScore = dict.SpendScore || 0;
    this.saveScore = dict.SaveScore || 0;
    this.borrowScore = dict.BorrowScore || 0;
    this.planScore = dict.PlanScore || 0;
    this.totalScore = dict.TotalScore || 0;
    this.wellnessLevel = dict.WellnessLevel || '';
}

// Model for check survey response
export function FinHealthCheckResponseModel(dict) {
    this.success = dict.success || false;
    this.code = dict.code || '';
    this.message = dict.message || '';
}
